import { useTheme } from '@mui/material';
import { blueGrey } from '@mui/material/colors';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { ListItemButtonLink } from './ListItemButtonLink';

export const InnerListItemButtonLink: React.FC<React.ComponentProps<typeof ListItemButtonLink>> = (props) => {
  const { children, ...otherProps } = props;
  const location = useLocation();
  const theme = useTheme();
  const isActive = location.pathname === otherProps.to;

  return (
    <ListItemButtonLink
      {...otherProps}
      onClick={event => isActive && event.preventDefault()}
      sx={{
        color: isActive ? theme.palette.tertiary.main : blueGrey['300'],
        borderLeft: `1px solid ${blueGrey[600]}`,
        marginLeft: '40px',
        paddingLeft: '24px',
        '&::before': {
          content: '""',
          position: 'absolute',
          left: '-1.5px',
          top: 0,
          bottom: 0,
          height: '25px',
          marginBottom: 'auto',
          marginTop: 'auto',
          width: '2px',
          backgroundColor: isActive ? theme.palette.tertiary.main : 'transparent',
          transition: 'opacity 300ms',
        },
        ...otherProps.sx,
      }}
    >
      {children}
    </ListItemButtonLink>
  );
};